import Vue from 'vue'

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

const vueToastification = Vue.use(Toast, {
  position: 'bottom-center',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: true,
  transition: 'Vue-Toastification__slideBlurred',
  maxToasts: 20,
  newestOnTop: true
})

export default vueToastification
